import type { CharacterIllustrationName } from './names';
import type { CharacterIllustrationDimensions } from './types';

/**
 * Intrinsic artwork dimensions, read from each asset's SVG viewBox at import
 * time. Most artworks are square; the exceptions carry their real aspect
 * ratio so renderers can derive height from a requested width.
 */
export const characterIllustrationDimensions: Record<
  CharacterIllustrationName,
  CharacterIllustrationDimensions
> = {
  'ai-conversation': { width: 364, height: 364 },
  'being-active': { width: 364, height: 364 },
  breathalyser: { width: 364, height: 364 },
  'care-team-at-work-emotional': { width: 364, height: 364 },
  'care-team-at-work-functional': { width: 364, height: 364 },
  'carrying-boat': { width: 364, height: 364 },
  'character-a': { width: 364, height: 364 },
  'character-b': { width: 364, height: 364 },
  'character-c': { width: 364, height: 364 },
  'character-d': { width: 364, height: 364 },
  cyclist: { width: 364, height: 364 },
  exploring: { width: 364, height: 364 },
  family: { width: 364, height: 364 },
  'feeling-support': { width: 364, height: 364 },
  fireworks: { width: 364, height: 364 },
  'friends-celebration': { width: 364, height: 364 },
  'getting-started-beach': { width: 364, height: 364 },
  'getting-started-boat': { width: 364, height: 364 },
  'growth-lg': { width: 364, height: 233 },
  'growth-sm': { width: 364, height: 364 },
  guidance: { width: 364, height: 364 },
  'helping-lg': { width: 555, height: 401 },
  'helping-sm': { width: 364, height: 364 },
  'high-five': { width: 364, height: 364 },
  'home-delivery': { width: 364, height: 364 },
  'how-to-use-it': { width: 364, height: 364 },
  'human-emotions': { width: 364, height: 364 },
  'ice-cream-fail': { width: 364, height: 364 },
  idea: { width: 364, height: 364 },
  juggle: { width: 364, height: 364 },
  'living-room': { width: 364, height: 262 },
  'looking-ahead-lg': { width: 508, height: 263 },
  'looking-ahead-sm': { width: 364, height: 364 },
  'man-thumbs-up': { width: 364, height: 364 },
  'man-waving': { width: 364, height: 364 },
  map: { width: 363, height: 364 },
  meditation: { width: 364, height: 364 },
  'member-taking-medication-alcohol': { width: 364, height: 364 },
  'member-taking-medication-tobacco': { width: 364, height: 364 },
  'member-taking-urine-test': { width: 364, height: 364 },
  'member-using-app': { width: 364, height: 364 },
  'member-using-app-blue': { width: 364, height: 364 },
  'mindfulness-activities-relaxing': { width: 364, height: 364 },
  'nature-landscape': { width: 364, height: 333 },
  'nature-relaxation': { width: 364, height: 364 },
  'negative-thoughts': { width: 364, height: 364 },
  notifications: { width: 364, height: 364 },
  'office-space': { width: 364, height: 333 },
  'overcoming-obstacles': { width: 364, height: 364 },
  'peaceful-butterfly': { width: 364, height: 364 },
  'picking-fruit': { width: 364, height: 364 },
  progress: { width: 366, height: 366 },
  'progress-wide': { width: 591, height: 366 },
  'reading-book': { width: 364, height: 364 },
  'reading-card': { width: 364, height: 364 },
  'reading-map': { width: 364, height: 364 },
  relapse: { width: 364, height: 364 },
  'relationship-interaction': { width: 364, height: 364 },
  'relaxing-together': { width: 280, height: 171 },
  rowing: { width: 364, height: 364 },
  'sailing-together-lg': { width: 524, height: 374 },
  'sailing-together-sm': { width: 408, height: 374 },
  'save-money': { width: 364, height: 364 },
  'setting-goals-archery': { width: 364, height: 364 },
  'setting-goals-calendar': { width: 364, height: 364 },
  skipping: { width: 364, height: 364 },
  success: { width: 364, height: 364 },
  thinking: { width: 364, height: 364 },
  'waking-up': { width: 364, height: 364 },
  walking: { width: 364, height: 364 },
  'walking-bridge-lg': { width: 364, height: 364 },
  'walking-bridge-sm': { width: 364, height: 364 },
  'watering-plant': { width: 364, height: 364 },
  welcome: { width: 364, height: 364 },
  'well-done': { width: 364, height: 364 },
  'woman-thumbs-up': { width: 364, height: 364 },
  'woman-thumbs-up-2': { width: 364, height: 364 },
};
